export const messagingDiagnosticsFilterLimit = 250;

export const messagingDiagnosticsCampaignsForFilter =
  "/:app_group_id/messaging_diagnostics/campaigns_for_filter" as const;
export const messagingDiagnosticsCanvasesForFilter =
  "/:app_group_id/messaging_diagnostics/canvases_for_filter" as const;
export const messagingDiagnosticsCanvasStepsForFilter =
  "/:app_group_id/messaging_diagnostics/canvas_steps_for_filter" as const;
